import { ERegion } from "./ERegion";
import { EPlatform } from "./EPlatform";

export class ACCProjectRequestAccess
{
    public reasonForAccess: string = '';
    public accountID: string = '';
    public projectName: string = '';
    public projectID: string = '';
    public userEmail: string = '';
    public roleName: string = '';
    public roleID: string = '';
    public region: ERegion = ERegion.US; // default value
    public platform: EPlatform = EPlatform.ACC;
}
